import { Link } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { semanticColors } from "../../utils/colors";

export default function DownloadButton({ url }: any) {
  return url ? (
    <Link
      href={url}
      // The receipt opens in its own tab: navigating away would drop whatever
      // the professional had filtered or paged to in the history.
      target="_blank"
      rel="noopener noreferrer"
      style={{
        cursor: "pointer",
        color: semanticColors.text.link
      }}
    >
      <FileDownloadIcon style={{ width: "26px", height: "26px" }} />
    </Link>
  ) : (
    <ErrorOutlineIcon style={{ width: "26px", height: "26px" }} />
  );
}
